import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class MasterService {
    baseUrl: string = 'Master.svc';
    constructor(private http: Http, private _ajaxService: AjaxService) {
    }
    selectMaster(type,id,parentId,searchText,lastRecord) {        
        return this._ajaxService.GET(this.baseUrl + "/master/"
                                + type + "/" 
                                + (typeof id == 'undefined' ? 0 : id) + "/" 
                                + (typeof parentId == 'undefined' ? 0 : parentId) + "/"
                                + (typeof searchText == 'undefined' ? ' ' : searchText) + "/"
                                + (typeof lastRecord == 'undefined' ? 0 : lastRecord));        
    }
    all(typeId,pageIndex,pageSize,sortHeaderName,sortDirection,filterText) {        
        return this._ajaxService.GET(this.baseUrl + "/all/" + typeId + "/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterText); 
    }
    save(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/save", dataToBePost);        
    }
    select(id) {        
        return this._ajaxService.GET(this.baseUrl + "/select/" + id); 
    }
    delete(id) {        
        return this._ajaxService.GET(this.baseUrl + "/delete/" + id); 
    }
    selectLanguage(id){
        return this._ajaxService.GET(this.baseUrl + "/selectLanguage/" + id); 
    }
    saveGeneralByLanguage(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/umSave", dataToBePost);        
    }
    selectPageAccess(id) {        
        return this._ajaxService.GET(this.baseUrl + "/selectPageAccess/"+ (typeof id == "undefined" ? 0 : id));        
    }
    paSave(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/paSave", dataToBePost);        
    }
    selectSysData(type,id) {        
        return this._ajaxService.GET("SystemData.svc/SystemAttrLanguage/"+ type + "/" + (typeof id == "undefined" ? 0 : id));        
    }
    cccDetail(id) {        
        return this._ajaxService.GET(this.baseUrl + "/cccDetail/" + id); 
    }
    actualCountryCode(customerCountryId) {        
        return this._ajaxService.GET(this.baseUrl + "/selectActualCountryCode/" + customerCountryId); 
    }
    selectDepotTypeConfig(customerDistributorId, orderId) {        
        return this._ajaxService.GET(this.baseUrl + "/selectDepotTypeConfig/" + customerDistributorId + '/' + orderId); 
    }
}




// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/master.service.ts